class MsgUtil {

    static getKeynoteList(content) {
        let re = /\{{1,2}([a-zA-z0-9\.\_]+\.DATA)\}{1,2}/g;
        let keys = content.match(re);
        let keynote_list = [];
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let index = content.indexOf(key);
            let word = '';
            if (index > 0 && content[index - 1] == '：') {
                for (let m = index - 2; m >= 0; m--) {
                    if (word.indexOf('TEMP_MXD_ENTER') == 0) {
                        word = word.replace('TEMP_MXD_ENTER', '');
                        break;
                    }
                    word = content[m] + word;
                }
            }
            if (word.length == 0 && key == '{{first.DATA}}') {
                word = '消息开头'
            }
            if (word.length == 0 && key == '{{remark.DATA}}') {
                word = '消息结尾'
            }
            key = this.getTemplateKey(key);
            keynote_list.push({
                key: key,
                word: word
            });
        }
        keynote_list.push({
            key: 'url',
            word: '跳转链接'
        });
        keynote_list.push({
            key: 'miniprogram',
            word: '跳转小程序'
        });
        return keynote_list;
    }

    static getTemplateKey(key) {
        var re = new RegExp("{", "g");
        var keymp = key.replace(re, '');
        re = new RegExp("}", "g");
        keymp = keymp.replace(re, '');
        re = new RegExp(".DATA", "g");
        keymp = keymp.replace(re, '');
        return keymp;
    }
}

export default MsgUtil